import { OrganizationRoles } from '~/constants/organizations'
import { WorkspaceRoles } from '~/constants/workspaces'

export const getRoleName = (role: OrganizationRoles | WorkspaceRoles) => {
  const { $i18n } = useNuxtApp()
  switch (role) {
    case OrganizationRoles.Suspended:
    case WorkspaceRoles.Suspended:
      return $i18n.t('common.roles.suspended')
    case OrganizationRoles.Viewer:
    case WorkspaceRoles.Viewer:
      return $i18n.t('common.roles.viewer')
    case OrganizationRoles.User:
    case WorkspaceRoles.User:
      return $i18n.t('common.roles.user')
    case OrganizationRoles.Admin:
    case WorkspaceRoles.Admin:
      return $i18n.t('common.roles.admin')
    case OrganizationRoles.Owner:
    case WorkspaceRoles.Owner:
      return $i18n.t('common.roles.owner')
    default:
      return '—'
  }
}

export const getOrganizationRolesOptions = () => {
  return Object.values(OrganizationRoles)
    .filter(roleValue => typeof roleValue === 'number')
    .map((roleValue) => {
      return {
        label: getRoleName(roleValue as OrganizationRoles | WorkspaceRoles),
        value: roleValue,
      }
    })
}

export const getWorkspaceRolesOptions = () => {
  return Object.values(OrganizationRoles)
    .filter(roleValue => typeof roleValue === 'number')
    .map((roleValue) => {
      return {
        label: getRoleName(roleValue as OrganizationRoles | WorkspaceRoles),
        value: roleValue,
      }
    })
}
